import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import { forwardRef, useEffect, useRef, useReducer, useCallback, useMemo } from "react";
import merge from "deepmerge";
import TextField from "./TextField";
import HiddenField from "./HiddenField";
import styles from "@/styles/Form.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var initializeValue = {
  passcode: "",
  passcodes: {
    1: null,
    2: null,
    3: null,
    4: null
  }
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case "change":
      var newState = merge(state, {
        passcodes: action.value
      });
      newState.passcode = Object.values(newState.passcodes).join("");
      return newState;

    case "reset":
      return initializeValue;
  }
};

var PasscodeField = /*#__PURE__*/forwardRef(function (props, ref) {
  var error = props.error,
      initialFocus = props.initialFocus,
      defaultValue = props.defaultValue,
      onChange = props.onChange,
      onInputCompleted = props.onInputCompleted;

  var _useReducer = useReducer(reducer, initializeValue),
      state = _useReducer[0],
      dispatch = _useReducer[1];

  var passcodeRefs = {
    1: useRef(),
    2: useRef(),
    3: useRef(),
    4: useRef()
  };

  var _useMemo = useMemo(function () {
    if (defaultValue && defaultValue.length == 4) {
      return defaultValue.split("");
    } else {
      return [];
    }
  }, [defaultValue]),
      val1 = _useMemo[0],
      val2 = _useMemo[1],
      val3 = _useMemo[2],
      val4 = _useMemo[3];

  var handleChange = useCallback(function (idx) {
    return function (e) {
      dispatch({
        type: "change",
        value: _defineProperty({}, idx, e.target.value)
      });

      if (e.target.value) {
        var next = passcodeRefs[idx + 1];

        if (next && next.current) {
          next.current.focus();
        }
      } else {
        var prev = passcodeRefs[idx - 1];

        if (prev && prev.current) {
          prev.current.focus();
        }
      }
    };
  }, []);
  var handleFocus = useCallback(function (e) {
    e.target.select();
  }, []);
  var handleInput = useCallback(function (e) {
    if (!/^\d{1}$/.test(e.target.value)) {
      e.target.value = null;
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, []);
  useEffect(function () {
    if (state.passcode) {
      if (onChange) {
        onChange(state.passcode);
      }

      if (onInputCompleted && state.passcode.length === 4) {
        onInputCompleted(state.passcode);
      }
    }
  }, [state.passcode]);
  useEffect(function () {
    var timeoutId;

    if (passcodeRefs[1] && passcodeRefs[1].current) {
      timeoutId = setTimeout(function () {
        if (initialFocus) {
          passcodeRefs[1].current.focus();
        }
      }, 10);
    }

    return function () {
      clearTimeout(timeoutId);
    };
  }, [initialFocus]);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsxs("div", {
      className: styles["passcodeFields"],
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.passcodeFieldsInner,
        children: [/*#__PURE__*/_jsx(TextField, {
          ref: passcodeRefs[1],
          name: "passcode1",
          maxLength: "1",
          inputMode: "numeric",
          onInput: handleInput,
          onFocus: handleFocus,
          onChange: handleChange(1),
          className: styles.passcodeField,
          defaultValue: val1,
          autoComplete: "off",
          textSecurity: true
        }), /*#__PURE__*/_jsx(TextField, {
          ref: passcodeRefs[2],
          name: "passcode2",
          maxLength: "1",
          inputMode: "numeric",
          onInput: handleInput,
          onFocus: handleFocus,
          onChange: handleChange(2),
          className: styles.passcodeField,
          defaultValue: val2,
          autoComplete: "off",
          textSecurity: true
        }), /*#__PURE__*/_jsx(TextField, {
          ref: passcodeRefs[3],
          name: "passcode3",
          maxLength: "1",
          inputMode: "numeric",
          onInput: handleInput,
          onFocus: handleFocus,
          onChange: handleChange(3),
          className: styles.passcodeField,
          defaultValue: val3,
          autoComplete: "off",
          textSecurity: true
        }), /*#__PURE__*/_jsx(TextField, {
          ref: passcodeRefs[4],
          name: "passcode4",
          maxLength: "1",
          inputMode: "numeric",
          onInput: handleInput,
          onFocus: handleFocus,
          onChange: handleChange(4),
          className: styles.passcodeField,
          defaultValue: val4,
          autoComplete: "off",
          textSecurity: true
        })]
      }), /*#__PURE__*/_jsx(HiddenField, {
        ref: ref,
        name: "passcode",
        value: state.passcode,
        error: error
      })]
    })
  });
});
PasscodeField.displayName = "PasscodeField";
export default PasscodeField;